import angular from 'angular';

import ComponentModule from './component';
import NotificationsComponent from './notifications.cmpt';

export default angular
    .module('application.component.notifications', [
        ComponentModule.name
    ])
    .component(NotificationsComponent.selector, NotificationsComponent);



// WEBPACK FOOTER //
// ./src/application/component/notifications/index.js